import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import ProductCard from "./ProductCard";
import { deleteData } from "../../hooks/delete";
import Swal from "sweetalert2";
import useSession from "../../hooks/useSession";

function ProductsListPage() {
  const { productsApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(productsApi);
  const [filteredData, setFilteredData] = useState([]);
  const [user] = useSession();

  // filter by slug
  useEffect(() => {
    setFilteredData(apiData.filter((item) => !item.slug));
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(productsApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.data?._id?.length > 0;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-6 lg:gap-8 p-4">
      <ProductCard />
      {filteredData?.map((item, key) => (
        <ProductCard
          key={key}
          project={item}
          handleSingleDelete={handleSingleDelete}
          user={user.role}
        />
      ))}
    </div>
  );
}

export default ProductsListPage;
